<template>
  <van-tabs class="family-cnt" v-model:active="active" color="#07c160">
    <van-tab title="家族招募助手">
      <Form>

        <Field v-model="config.familyId" type="number" placeholder="家族ID" label="家族ID"/>
        <Field v-model="config.crewTimeStart" autocomplete="off" type="text" placeholder="开始时间" label="开始时间" @focus="doShowTimePicker('crewTimeStart')"/>
        <Field v-model="config.crewTimeEnd" autocomplete="off" type="text" placeholder="停止时间" label="停止时间" @focus="doShowTimePicker('crewTimeEnd')"/>
        <Field v-model="config.crewJobPeriod" type="number" placeholder="招募间隔" label="招募间隔(秒)">
        </Field>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">文案招募</label><!----></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.crewAd" />
            </div>
          </div><!----><!---->
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">自动切换频道</label><!----></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.autoChangeChannel" />
            </div>
          </div><!----><!---->
        </div>
        <van-cell-group inset>
          <div class="van-cell van-field">
            <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">招募文案</label><!----></div>
            <div class="van-cell__value van-field__value">
              <van-button size="small" type="primary" @click="addCrewAdTexts">添加多文案</van-button>
            </div><!----><!---->
          </div>
          <Field v-for="(adText, index) in config.crewAdTexts" type="textarea" v-model="config.crewAdTexts[index]" placeholder="招募文案组" :label="null" :key="index">
            <template #button>
              <van-button size="small" type="danger" @click="delCrewAdTexts(index)">删除</van-button>
            </template>
          </Field>
        </van-cell-group>

        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">红包招募</label><!----></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.sendCrewPacket" />
            </div>
          </div><!----><!---->
        </div>
        <Field type="text" v-model="config.crewRedPacketText" placeholder="招募红包文案" label="招募红包文案"></Field>
        <Field type="text" v-model="config.crewRedPacketAmount" placeholder="招募红包金额" label="招募红包金额"></Field>
        <Field type="text" v-model="config.crewRedPacketJobPeriod" placeholder="招募红包间隔" label="招募间隔(秒)"></Field>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">本地广场招募</label><!----></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.adForLocal" />
            </div>
          </div><!----><!---->
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">私信招募</label><!----></div>
          <div class="van-cell__value van-field__value">
              <div class="van-field__body">
                <van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.crewInvite" />
              </div>
          </div><!----><!---->
        </div>
        <div v-if="config.canInviteFamilyUser" class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input" tips="">邀有家族用户</label><!----></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.inviteFamilyUser" />
            </div>
          </div><!----><!---->
        </div>
        <Field type="number" v-model="config.repeatInviteCount" label="重复邀请次"/>
        <Field type="number" v-model="config.repeatInvitePeriod" label="邀请间隔(小时)"/>
        <p class="form-tips">*需要开启 文案招募,私信招募,红包招募之一才会在广场发送广告哦</p>
        <div class="button-wrap">
          <Button type="primary" @click="doSaveConfig">保存</Button>
          <Button type="primary" @click="config.showQrCode=true">配置二维码</Button>
        </div>
      </Form>
    </van-tab>
    <van-tab title="家族小管家">
      <Form>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">管家状态</label><!----></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.autoManageFamily" />
            </div>
          </div><!----><!---->
        </div>
        <Field v-model="config.robotNick" placeholder="管家昵称" label="管家昵称"/>
        <Field v-model="config.welcomeMsg" placeholder="欢迎新人文案" label="欢迎新人文案"></Field>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">新人和死群自动发送红包</label><!----></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.autoSendRedPacket" />
            </div>
          </div><!----><!---->
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">死群自动发消息</label><!----></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.deadGroupSendMsg" />
            </div>
          </div><!----><!---->
        </div>
        <Field type="number" v-model="config.timeSendRedPacketInterval" placeholder="定时红包间隔(分钟)" label="定时红包间隔(分钟)"></Field>
        <Field type="number" v-model="config.timedSendRedPacketNum" placeholder="定时红包个数" label="定时红包个数"></Field>
        <Field type="number" v-model="config.timedSendRedPacketAmount" placeholder="定时红包金额" label="定时红包金额"></Field>

        <Field type="number" v-model="config.bountyTaskInterval" placeholder="悬赏间隔(分钟)" label="悬赏间隔(分钟)"></Field>
        <Field type="number" v-model="config.bountyTaskRedpacketNum" placeholder="悬赏红包数" label="悬赏红包数"></Field>
        <Field type="number" v-model="config.bountyTaskRedpacketAmount" placeholder="悬赏红包金额" label="悬赏红包金额"></Field>

        <Field type="textarea" v-model="config.familyWhiteUserList" placeholder="免踢名单" label="免踢名单"></Field>
        <Field type="number" v-model="config.needCrewNum" placeholder="招募门槛人数" label="招募人数门槛"></Field>
        <Field type="number" v-model="config.needCleanNum" label="清理门槛人数"/>
        <Field type="textarea" v-model="config.notifyAllMemberPeriodMsg" label="3小时发一次群消息内容"/>
        <Field type="textarea" v-model="config.rewardGoldCoinMsg" label="21点定时提醒消息内容"/>
        <p class="form-tips">家族清理优先级: 进群30分钟发言条数小于20</p>
        <div class="button-wrap">
          <Button type="primary" @click="doSaveConfig">保存</Button>
          <Button type="primary" @click="config.showQrCode=true">配置二维码</Button>
        </div>
      </Form>
    </van-tab>
    <van-tab title="家族数据">
      <p class="ctn-tip">敬请期待</p>
    </van-tab>
  </van-tabs>
  <van-overlay :show="config.showQrCode" @click="config.showQrCode = false">
    <div class="loading-wrapper">
      <div ref="alipayWap" style="text-align: left">
        <div style="display: flex;align-items: center;justify-content: center;"><vue-qrcode :value="config.configUrl"></vue-qrcode></div>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: 1rem;"><Button type="primary" @click="config.showQrCode = false">关闭</Button></div>
      </div>
    </div>
  </van-overlay>
  <van-popup v-model:show="config.showTimePicker" position="bottom" :style="{width: '100%'}">
    <van-time-picker
        title="选择时间"
        v-model="config.timePickerVale"
        @confirm="onTimePickerChange"
    />
  </van-popup>
</template>
<style lang="less">
@import "@/app.less";
.family-cnt{
  .van-cell__title{
    width: 6rem;
    color: @black1;
  }

  .van-field__control{
    color: #666;
  }

  .form-tips{
    color: @color2;
    text-align: left;
    padding: 0 1rem 0 1rem;
  }
  .button-wrap{
    display: flex;
    justify-content: space-evenly;
  }
}

</style>

<script>
import {Button, Field, Form, showNotify} from "vant";
import store from "@/store";
import {onMounted, ref} from "vue";
import ClipbordComponent from "@/components/Clipbord.vue";
import API from "@/api";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import Clipbord from "@/components/Clipbord.vue";

export default {
  name: 'FamilyConfig',
  components: {Clipbord, VueQrcode, Form, Field, ClipbordComponent, Button},
  setup(){
    /**
     * {FamilyClientConfig}
     */
    const config = ref({
      robotNick:"",
      sendWelcomeMsg: true,
      welcomeMsg: "欢迎加入! 回归、违规100/8, 返榜私族长, 每日猴子、签到任务必做, 满员自动清理, 多多活跃, 早日脱单!",
      autoSendRedPacket: false,
      crewRedPacketText: "温馨家族招人",
      crewRedPacketAmount: 30,
      crewRedPacketJobPeriod: 10,
      repeatInvitePeriod: 24,
      familyWhiteUserList: "",
      needCrewNum: 225,
      needCleanNum: 229,
      canInviteFamilyUser:false,
      deadGroupSendMsg:false,
      autoManageFamily: false,
      crewAdTexts:[],
      timeSendRedPacketInterval: 60,
      timedSendRedPacketAmount: 150,
      timedSendRedPacketNum: 1,
      bountyTaskInterval: 180,
      bountyTaskRedpacketNum:6,
      bountyTaskRedpacketAmount:1,
      crewTimeStart:null,
      crewTimeEnd:null,
      showTimePicker: false,
      timePickerType: "",
      timePickerVale: null,
    });

    const userStore = store.userStore();

    const familyStore = store.familyStore();

    onMounted(async () => {
      const res = await familyStore.getFamilyClientConfig(userStore.getDeviceId());
      if(res.success){
        if(res.data.crewAdTexts == null){
          res.data.crewAdTexts = [];
        }

        config.value = res.data;
        config.value.configUrl="https://www.haoping.fun/family-config?deviceId=" + encodeURIComponent(userStore.getDeviceId());
      }
    });

    return {config};
  },
  methods: {
    async doSaveConfig() {
      const config = this.config;
      if(!config.canInviteFamilyUser){
        config.inviteFamilyUser = false;
      }


      const params = Object.assign({}, config);
      params.canInviteFamilyUser = null;

      const res = await API.family.doSetFamilyClientConfig({config:params, deviceId: store.userStore().getDeviceId()});
      if(res.success){
        showNotify({type:"success", message: "保存成功" });
      }else{
        showNotify({type:"warning", message: res.errorMsg});
      }
    },
    addCrewAdTexts(){
      const config = this.config;
      config.crewAdTexts.push("");
    },
    delCrewAdTexts(index){
      const config = this.config;
      config.crewAdTexts.splice(index,1)
    },
    doShowTimePicker(pickerType){
      const config = this.config;
      config.timePickerType = pickerType;
      config.showTimePicker = true;
      if(config.timePickerType === "crewTimeStart" && config.crewTimeStart){
        config.timePickerVale = config.crewTimeStart.split(":");
      }

      if(config.timePickerType === "crewTimeEnd" && config.crewTimeEnd){
        config.timePickerVale = config.crewTimeEnd.split(":");
      }
    },
    onTimePickerChange({selectedValues, selectedOptions, selectedIndexes, columnIndex}){
      const config = this.config;
      config.timePickerVale = selectedValues;
      config.showTimePicker = false;
      if(config.timePickerType === "crewTimeStart"){
        config.crewTimeStart = selectedValues.join(":");
      }

      if(config.timePickerType === "crewTimeEnd"){
        config.crewTimeEnd = selectedValues.join(":");
      }
    }
  }
}
</script>
